/* eslint-disable no-unused-expressions */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useState } from 'react';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import MenuItem from '@material-ui/core/MenuItem';
import TableGrid from '../Table/tableGrid';
import {
  manuFactureChildHead,
  ProviderHead,
  manuFactureHead,
  groupTableHead,
  superClientModalHead,
  clientGroupPlanHead,
  contractTableHead,
} from '../../Modules/Maintain/Manufacturer/components/gridComponents/copyContactTableHead';
import {
  getAllManufacturer,
  getCopyContactDropdownList,
  getGetAllProviderList,
  getAllClientGroupList,
  getAllClientGroupByPlanList,
  getAllClientListData,
  getGetAllContractList,
  getExistingContactList,
} from '../../Modules/Maintain/Manufacturer/store/ManufacturerAction';
import Spinner from '../Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../AgGridUtilities/suppressNavigation';
import PDFExportPanel from '../pdfExport/PDFExportPanel';
import showPreloader from '../../interceptor/store/Actions';

function CopyContact(props) {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const ManufacturerData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer?.manufacturerList?.data;
  });
  const createMFG = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.selectManufacturerData
      .createManufacturer;
  });
  const getSelectOptions = useSelector(
    (state) => state.sharedState.ManufacturerReducer.getAllDropdownValues
  );
  const FetchAllClientGroupList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allClientGroupList
  );
  const FetchAllClientGroupPlanList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allClientGroupPlanList
  );
  const FetchAllClientListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allClientListData
  );
  const FetchAllContractListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allContractListData
  );
  const FetchAllProviderListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allProviderListData
  );
  const FetchAllExistingContactList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.getAllExistingContactList
  );
  const { setSelectedContact, entityType, mfgId, filterId, contactType } =
    props;

  const [showAll, setShowAll] = React.useState(false);
  const superChildRef = React.useRef(null);
  const childRef = React.useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [gridApi1, setGridApi1] = useState(null);
  const [columnApi1, setColumnApi1] = useState(null);
  const [gridParams, setGridParams] = React.useState('');
  const [childGridParams, setChildGridParams] = React.useState('');
  const [applyFilter, setApplyFilter] = React.useState(false);
  const [totalResultCount, setTotalResultCount] = React.useState(0);
  const [childApplyFilter, setChildApplyFilter] = React.useState(false);
  const [ChildTotalResultCount, setChildTotalResultCount] = React.useState(0);
  const [selectedOption, setSelectedOption] = useState(entityType);
  const [rowData, setRowData] = React.useState([]);
  const [childData, setChildData] = React.useState([]);

  // select row on ag-grid table
  const getSelectedRow = (data, selectVal) => {
    dispatch(getExistingContactList(null));
    setChildData([]);
    if (selectVal === 'CG' && data?.cg_id) {
      getExistingContacts(data.cg_id, 'CG');
    } else if (selectVal === 'CGP' && data?.cgpId) {
      getExistingContacts(data.cgpId, 'CGP');
    } else if (selectVal === 'CLIENT' && data?.clientId) {
      getExistingContacts(data.clientId, 'CLIENT');
    } else if (selectVal === 'CONTRACT') {
      getExistingContacts(data.contractNum, 'CONTRACT');
    } else if (selectVal === 'MFG' && data?.mfgId) {
      getExistingContacts(data.mfgId, 'MFG');
    } else if (selectVal === 'TYPEPROV' && data?.providerTypeCDAndId) {
      getExistingContacts(data.providerTypeCDAndId, 'TYPEPROV');
    }
  };

  //fetch data based on selected entity type
  const fetchRowData = async (selectedEntityType) => {
      switch(selectedEntityType){   
        case 'CLIENT':
          if (!FetchAllClientListData?.length > 0)
             await dispatch(getAllClientListData(''));
          break;
        case 'CGP':
          if (!FetchAllClientGroupPlanList?.length > 0)
             await dispatch(getAllClientGroupByPlanList(''));
          break;
        case 'CG':
          if (!FetchAllClientGroupList?.length > 0)
             await dispatch(getAllClientGroupList(''));
          break;
        case 'CONTRACT':
          if (!FetchAllContractListData?.length > 0)
             await dispatch(
              getGetAllContractList({ showAllInd: true, mfgId: null })
            );
          break;
        case 'TYPEPROV':
          if (!FetchAllProviderListData?.length > 0) {
             try {
               setLoading(true);
               await dispatch(getGetAllProviderList(''));
             } finally {
               setLoading(false);
               setTimeout(() => dispatch(showPreloader(false)), 3000);
             }
          }
          break;
        case 'MFG':
          if (!ManufacturerData?.length > 0)
             await dispatch(getAllManufacturer({ mfgId: null, showAllInd: true }));
          break;          
      }
         if (!ManufacturerData?.length > 0)
            dispatch(getAllManufacturer({ mfgId: null, showAllInd: true }));
            dispatch(getExistingContactList(null));
  }

  // set All dropdown option and data
  React.useEffect(() => {
    (async () => {
      setLoading(false);
      setChildApplyFilter(false);
      setApplyFilter(false);
      if (!getSelectOptions?.length > 0)
        await dispatch(getCopyContactDropdownList(''));
      if (selectedOption) {
        try {
          setLoading(true);
          await fetchRowData(selectedOption);
        } finally {
          setLoading(false);
        }
      }
      if (filterId && entityType === selectedOption) {
        const Obj = {};
        if (entityType === 'CLIENT') {
          Obj.clientId = filterId;
        } else if (entityType === 'CGP') {
          Obj.cgpId = filterId;
        } else if (entityType === 'TYPEPROV') {
          Obj.providerTypeCDAndId = filterId;
        } else if (entityType === 'CG') {
          Obj.cg_id = filterId;
        }
        getSelectedRow(Obj, entityType);
      }
      if (entityType !== 'TYPEPROV') {
        setTimeout(() => dispatch(showPreloader(false)), 3000);
      }

      setLoading(false);
    })();
  }, []);
  // FetchAllExistingContact select MFg id
  React.useEffect(() => {
    setChildData(FetchAllExistingContactList);
    if (selectedOption === 'TYPEPROV') {
      setTimeout(() => dispatch(showPreloader(false)), 500);
    }
    if (FetchAllExistingContactList && FetchAllExistingContactList.length > 0) {
      setTimeout(() => {
        if (childGridParams) {
          childGridParams.api.forEachNode((node) =>
            node.rowIndex ? 1 : node.setSelected(true)
          );
          childGridParams.api.setFilterModel(null);
        }
      }, 100);
    }
  }, [FetchAllExistingContactList]);
  // set manufacturer list on page load
  React.useEffect(() => {
    if (
      ManufacturerData &&
      ManufacturerData?.length > 0 &&
      selectedOption === 'MFG'
    ) {
      setRowData(ManufacturerData);
    }
  }, [ManufacturerData]);
  React.useEffect(() => {
    if (
      FetchAllClientListData &&
      FetchAllClientListData?.length > 0 &&
      selectedOption === 'CLIENT'
    ) {
      setRowData(
        FetchAllClientListData.filter((x) => {
          if (!showAll && entityType === 'CLIENT') {
            return x.clientId === filterId;
          }
          return x;
        })
      );
    }
  }, [FetchAllClientListData]);
  React.useEffect(() => {
    if (
      FetchAllClientGroupList &&
      FetchAllClientGroupList?.length > 0 &&
      selectedOption === 'CG'
    ) {
      setRowData(
        FetchAllClientGroupList.filter((x) => {
          if (!showAll && entityType === 'CG') {
            return x.cg_id === filterId;
          }
          return x;
        })
      );
    }
  }, [FetchAllClientGroupList]);
  React.useEffect(() => {
    if (
      FetchAllClientGroupPlanList &&
      FetchAllClientGroupPlanList?.length > 0 &&
      selectedOption === 'CGP'
    ) {
      setRowData(
        FetchAllClientGroupPlanList.filter((x) => {
          if (!showAll && entityType === 'CGP') {
            return x.cgpId === filterId;
          }
          return x;
        })
      );
    }
  }, [FetchAllClientGroupPlanList]);

  React.useEffect(()=>{
    if (
      selectedOption === 'CONTRACT' &&
      FetchAllContractListData &&
      FetchAllContractListData?.length > 0
    ) {
      setRowData(FetchAllContractListData);
    }
  }, [FetchAllContractListData]);

  React.useEffect(() => {
    if (
      FetchAllProviderListData &&
      FetchAllProviderListData?.length > 0 &&
      selectedOption === 'TYPEPROV'
    ) {
      setRowData(
        FetchAllProviderListData.filter((x) => {
          if (!showAll && entityType === 'TYPEPROV') {
            return x.providerTypeCDAndId === filterId;
          }
          return x;
        })
      );
      setTimeout(() => {
        if (gridParams) {
          gridParams?.api?.forEachNode((node) =>
            node.rowIndex ? 1 : node.setSelected(true)
          );
          gridParams?.api?.setFilterModel(null);
          getSelectedRow(
            FetchAllProviderListData.filter((x) => {
              if (entityType === 'TYPEPROV') {
                return x.providerTypeCDAndId === filterId;
              }
              return x;
            })[0],
            'TYPEPROV'
          );
        }
      }, 100);
    }
  }, [FetchAllProviderListData]);
  const handleSetDataOnGrid = (val) => {
    if (ManufacturerData && ManufacturerData?.length > 0) {
      if (selectedOption === 'CG') {
        setRowData(
          FetchAllClientGroupList.filter((x) => {
            if (!val && entityType === 'CG') {
              return x.cg_id === filterId;
            }
            return x;
          })
        );
      } else if (selectedOption === 'CGP') {
        setRowData(
          FetchAllClientGroupPlanList.filter((x) => {
            if (!val && entityType === 'CGP') {
              return x.cgpId === filterId;
            }
            return x;
          })
        );
      } else if (selectedOption === 'CLIENT') {
        setRowData(
          FetchAllClientListData.filter((x) => {
            if (!val && entityType === 'CLIENT') {
              return x.clientId === filterId;
            }
            return x;
          })
        );
      } else if (selectedOption === 'CONTRACT') {
        setRowData(FetchAllContractListData);
      } else if (selectedOption === 'TYPEPROV') {
        setRowData(
          FetchAllProviderListData.filter((x) => {
            if (!val && entityType === 'TYPEPROV') {
              return x.providerTypeCDAndId === filterId;
            }
            return x;
          })
        );
      } else {
        setRowData(ManufacturerData);
      }
      setTimeout(() => {
        if (gridParams) {
          gridParams.api.forEachNode((node) =>
            node.rowIndex ? 1 : node.setSelected(true)
          );
          gridParams.api.setFilterModel(null);
        }
      }, 100);
    }
  };
  // set Row Data if change dropdown values
  React.useEffect(() => {
    handleSetDataOnGrid(showAll);
  }, [selectedOption]);
  // select single row after call
  const handleOnSelect = (e) => {
    if (setSelectedContact) {
      setSelectedContact(null);
      setTimeout(() => dispatch(showPreloader(false)), 2000);
      setChildData([]);
      getSelectedRow(e.data, selectedOption);
    }
  };
  // set contact detail on select child table
  const childSelect = (e) => {
    if (setSelectedContact) {
      setTimeout(() => dispatch(showPreloader(false)), 2000);
      setSelectedContact(e.api.getSelectedRows() && e.api.getSelectedRows()[0]);
    }
  };

  // handing by default 1st row selection function
  const onGridReady = useCallback((params) => {
    setGridParams(params);
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    params.api.forEachNode((node) => {
      node.rowIndex ? 1 : node.setSelected(true);
    });
  });
  // handing by default 1st row selection function
  const onGridReadyChild = useCallback((params) => {
    setChildGridParams(params);
    setGridApi1(params.api);
    setColumnApi1(params.columnApi);
    params.api.forEachNode((node) =>
      node.rowIndex ? 1 : node.setSelected(true)
    );
  });
  // onchange event on dropdown
  const handleOnChange = async (e) => {
    setShowAll(false);
    setChildData([]);
    setRowData([]);
    setSelectedOption(e.target.value);
    
    try {
      setLoading(true);
      await fetchRowData(e.target.value);
    } finally {
      setLoading(false);
      const api = gridParams?.api || gridApi;
      if (api) {
        const first = api.getDisplayedRowAtIndex(0);
        if (first) {
          api.forEachNode((node) => node.setSelected(node.rowIndex === 0));
        } 
      }
    }
    if (
      e.target.value === 'CG' &&
      FetchAllClientGroupList &&
      FetchAllClientGroupList?.length > 0
    ) {
      getSelectedRow(
        FetchAllClientGroupList.filter((x) => {
          if (!showAll && entityType === 'CG') {
            return x.cg_id === filterId;
          }
          return x;
        })[0],
        e.target.value
      );
    } else if (
      e.target.value === 'CGP' &&
      FetchAllClientGroupPlanList &&
      FetchAllClientGroupPlanList?.length > 0
    ) {
      getSelectedRow(
        FetchAllClientGroupPlanList.filter((x) => {
          if (!showAll && entityType === 'CGP') {
            return x.cgpId === filterId;
          }
          return x;
        })[0],
        e.target.value
      );
    } else if (
      e.target.value === 'CLIENT' &&
      FetchAllClientListData &&
      FetchAllClientListData.length > 0
    ) {
      getSelectedRow(
        FetchAllClientListData.filter((x) => {
          if (!showAll && entityType === 'CLIENT') {
            return x.clientId === filterId;
          }
          return x;
        })[0],
        e.target.value
      );
    } else if (
      e.target.value === 'CONTRACT' &&
      FetchAllContractListData &&
      FetchAllContractListData?.length > 0
    ) {
      getSelectedRow(FetchAllContractListData[0], e.target.value);
    } else if (
      e.target.value === 'TYPEPROV' &&
      FetchAllProviderListData &&
      FetchAllProviderListData?.length > 0
    ) {
      getSelectedRow(
        FetchAllProviderListData.filter((x) => {
          if (!showAll && entityType === 'TYPEPROV') {
            return x.providerTypeCDAndId === filterId;
          }
          return x;
        })[0],
        e.target.value
      );
    } else if (
      e.target.value === 'MFG' &&
      ManufacturerData &&
      ManufacturerData?.length > 0
    ) {
      getSelectedRow(
        ManufacturerData.filter((x) => {
          if (!showAll && props?.mfgId) {
            return x.mfgId === props?.mfgId;
          }
          return x;
        })[0],
        e.target.value
      );
    }
  };

  React.useEffect(() => {
    if (!gridParams && !gridApi) return;
    const api = gridParams?.api || gridApi;
    if (!api) return;

    const rowCount = api.getDisplayedRowCount();
    if (rowCount > 0) {
      api.forEachNode((node) => node.setSelected(node.rowIndex === 0));
      const first = api.getDisplayedRowAtIndex(0);
      if (first && first.data) {
        dispatch(getExistingContactList(null));
        setChildData([]);
        getSelectedRow(first.data, selectedOption);
      }
    }
  }, [rowData, gridParams, gridApi]);
  // handling  clear filter
  const handleClearFilter = () => {
    if (childRef?.current) {
      childRef.current.clearFilters();
      setApplyFilter(false);
    }
  };
  //  handling  clear filter
  const handleClearFilterChild = () => {
    if (superChildRef?.current) {
      superChildRef.current.clearFilters();
      setChildApplyFilter(false);
    }
  };
  // get existing contact list
  const getExistingContacts = async (key, keyTypeCD) => {
    handleClearFilterChild();
    await dispatch(getExistingContactList({ key: key, keyTypeCD: keyTypeCD }));
    setLoading(false);
  };
  // handling Apply filter
  const onFilterChanged = useCallback((e) => {
    setTotalResultCount(e.api.getDisplayedRowCount());
    if (
      (e.api.getFilterModel() && Object.keys(e.api.getFilterModel())).length > 0
    ) {
      setApplyFilter(true);
    } else {
      setApplyFilter(false);
    }
  }, []);
  // Apply Filter
  const onFilterChangedChild = useCallback((e) => {
    setChildTotalResultCount(e.api.getDisplayedRowCount());
    if (
      (e.api.getFilterModel() && Object.keys(e.api.getFilterModel())).length > 0
    ) {
      setChildApplyFilter(true);
    } else {
      setChildApplyFilter(false);
    }
  }, []);
  // Ag-grid framework component
  const frameworkComponents = {
    nameRenderMFG: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.mfgName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderClient: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.clientName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderGroup: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.groupName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderContract: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.contractName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderProvider: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.name;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderPlan: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.planName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };
  const frameworkComponentsChild = {
    nameRenderChild: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.contactName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    copNameRender: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.corpName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  return (
    <>
      {loading && <Spinner load={loading} />}
      <div
        data-testid="copy-contact-popup"
        id="copy-contact-popup"
        className="common-popup"
      >
        <div className="panel tBillPanel-space devider-line pb-0">
          <form autoComplete="off">
            <div className="form-wrapper">
              <div className="mui-custom-form with-select  mfg-dropdown-width">
                <TextField
                  label="Entity Type"
                  defaultValue={selectedOption}
                  data-testid="drop-down"
                  fullWidth
                  required
                  select
                  placeholder=""
                  inputProps={{ maxlength: 11 }}
                  InputLabelProps={{ shrink: true }}
                  value={selectedOption}
                  onChange={(e) => handleOnChange(e)}
                >
                  {getSelectOptions
                    ?.filter((x) => x.value !== 'PROVIDER')
                    .map((x) => (
                      <MenuItem
                        key={x.value}
                        value={x.value}
                        className="frr-logcheck-dropdown-item"
                      >
                        {x.text}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
              <div className="mui-custom-form input-md">
                <div className="sub-radio text-black sub-label manufacture-frr-mt-27">
                  <FormControlLabel
                    control={
                      entityType === selectedOption ? (
                        <Checkbox
                          value={showAll}
                          data-testid="handleSetDataOnGrid"
                          checked={showAll}
                          onClick={(e) => {
                            dispatch(getExistingContactList(null));
                            setShowAll(e.target.checked);
                            setChildData([]);
                            handleSetDataOnGrid(e.target.checked);
                            if (
                              FetchAllClientListData &&
                              FetchAllClientListData?.length > 0 &&
                              entityType === 'CLIENT'
                            ) {
                              if (filterId) {
                                const tempObj = FetchAllClientListData.filter(
                                  (x) => {
                                    if (
                                      !e.target.checked &&
                                      entityType === 'CLIENT'
                                    ) {
                                      return x.clientId === filterId;
                                    }
                                    return x;
                                  }
                                );
                                if (tempObj && tempObj.length > 0) {
                                  getSelectedRow(tempObj[0], selectedOption);
                                }
                              } else {
                                const newObj = FetchAllClientListData.filter(
                                  (x) => {
                                    if (!e.target.checked) {
                                      return [];
                                    }
                                    return x;
                                  }
                                );
                                if (newObj && newObj.length > 0) {
                                  getSelectedRow(newObj[0], selectedOption);
                                }
                              }
                            }
                            if (
                              FetchAllClientGroupList &&
                              FetchAllClientGroupList?.length > 0 &&
                              entityType === 'CG'
                            ) {
                              if (filterId) {
                                const tempObj = FetchAllClientGroupList.filter(
                                  (x) => {
                                    if (
                                      !e.target.checked &&
                                      entityType === 'CG'
                                    ) {
                                      return x.cg_id === filterId;
                                    }
                                    return x;
                                  }
                                );
                                if (tempObj && tempObj.length > 0) {
                                  getSelectedRow(tempObj[0], selectedOption);
                                }
                              } else {
                                const newObj = FetchAllClientGroupList.filter(
                                  (x) => {
                                    if (!e.target.checked) {
                                      return [];
                                    }
                                    return x;
                                  }
                                );
                                if (newObj && newObj.length > 0) {
                                  getSelectedRow(newObj[0], selectedOption);
                                }
                              }
                            }
                            if (
                              FetchAllClientGroupPlanList &&
                              FetchAllClientGroupPlanList?.length > 0 &&
                              entityType === 'CGP'
                            ) {
                              if (filterId) {
                                const tempObj =
                                  FetchAllClientGroupPlanList.filter((x) => {
                                    if (
                                      !e.target.checked &&
                                      entityType === 'CGP'
                                    ) {
                                      return x.cgpId === filterId;
                                    }
                                    return x;
                                  });
                                if (tempObj && tempObj.length > 0) {
                                  getSelectedRow(tempObj[0], selectedOption);
                                }
                              } else {
                                const newObj =
                                  FetchAllClientGroupPlanList.filter((x) => {
                                    if (!e.target.checked) {
                                      return [];
                                    }
                                    return x;
                                  });
                                if (newObj && newObj.length > 0) {
                                  getSelectedRow(newObj[0], selectedOption);
                                }
                              }
                            }
                            if (
                              FetchAllProviderListData &&
                              FetchAllProviderListData?.length > 0 &&
                              entityType === 'TYPEPROV'
                            ) {
                              if (filterId) {
                                const tempObj = FetchAllProviderListData.filter(
                                  (x) => {
                                    if (
                                      !e.target.checked &&
                                      entityType === 'TYPEPROV'
                                    ) {
                                      return x.providerTypeCDAndId === filterId;
                                    }
                                    return x;
                                  }
                                );
                                if (tempObj && tempObj.length > 0) {
                                  getSelectedRow(tempObj[0], selectedOption);
                                }
                              } else {
                                const newObj = FetchAllProviderListData.filter(
                                  (x) => {
                                    if (!e.target.checked) {
                                      return [];
                                    }
                                    return x;
                                  }
                                );
                                if (newObj && newObj.length > 0) {
                                  getSelectedRow(newObj[0], selectedOption);
                                }
                              }
                            }
                          }}
                          color="primary"
                        />
                      ) : (
                        <Checkbox value checked disabled color="primary" />
                      )
                    }
                    label="Show All"
                    data-testid="showAll"
                  />
                </div>
              </div>
            </div>
          </form>
          <div className="panel-header mt-3">
            <div className="float-left mt-2">
              <p className="no-margin tbl-help-text">
                * Click on the record to view the details
              </p>
            </div>

            <div className="float-right th-icon-group mt-2">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="filter-tooltip">Reset All Filters</Tooltip>
                }
              >
                {applyFilter ? (
                  // eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
                  <div
                    className="th-icon ic-filter-activate"
                    data-testid="handleClearFilter"
                    role="button"
                    onClick={handleClearFilter}
                  >
                    <span className="ic-title"> Filter </span>{' '}
                  </div>
                ) : (
                  <div
                    data-testid="handleClearFilter"
                    className="th-icon ic-filter"
                  >
                    <span className="ic-title"> Filter </span>{' '}
                  </div>
                )}
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="history-tooltip"> Actions </Tooltip>}
              >
                <div className="th-icon ic-actions">
                  {' '}
                  <PDFExportPanel
                    gridApi={gridApi}
                    columnApi={columnApi}
                    fileName={
                      selectedOption === 'CG'
                        ? `${contactType}-CG`
                        : selectedOption === 'CGP'
                        ? `${contactType}-CGP`
                        : selectedOption === 'CLIENT'
                        ? `${contactType}-Client`
                        : selectedOption === 'CONTRACT'
                        ? `${contactType}-Contract`
                        : selectedOption === 'TYPEPROV'
                        ? `${contactType}-Provider`
                        : `${contactType}-MFG`
                    }
                    childRef={childRef}
                  />
                </div>
              </OverlayTrigger>
            </div>
            <div className="clearfix" />
          </div>
        </div>

        <div className="panel tBillPanel-space pb-0">
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <div className="frr-tbl-with-feature frr-ellipsis-text">
              {ManufacturerData && ManufacturerData.length > 0 ? (
                <TableGrid
                  ref={childRef}
                  onGridReady={onGridReady}
                  gridHeight={350}
                  rowData={rowData}
                  columnDefs={
                    selectedOption === 'CG'
                      ? groupTableHead
                      : selectedOption === 'CGP'
                      ? clientGroupPlanHead
                      : selectedOption === 'CLIENT'
                      ? superClientModalHead
                      : selectedOption === 'CONTRACT'
                      ? contractTableHead
                      : selectedOption === 'TYPEPROV'
                      ? ProviderHead
                      : manuFactureHead
                  }
                  fileName={
                    selectedOption === 'CG'
                      ? `${contactType}-CG`
                      : selectedOption === 'CGP'
                      ? `${contactType}-CGP`
                      : selectedOption === 'CLIENT'
                      ? `${contactType}-Client`
                      : selectedOption === 'CONTRACT'
                      ? `${contactType}-Contract`
                      : selectedOption === 'TYPEPROV'
                      ? `${contactType}-Provider`
                      : `${contactType}-MFG`
                  }
                  cellClickedListener={(e) => handleOnSelect(e)}
                  onFilterChanged={onFilterChanged}
                  data-testid="onEditingStopped"
                  setTotal={setTotalResultCount}
                  childPopup
                  frameworkComponents={frameworkComponents}
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                />
              ) : null}
            </div>
          </div>

          <p className="total-results" tabIndex="0">
            Total Results:<b>{totalResultCount?.toLocaleString('en-US')}</b>
          </p>
          <div className="panel-header mt-3">
            <div className="float-left mt-2">
              <label className="frr-label-font">Available Contacts</label>
            </div>
            <div className="float-right th-icon-group mt-2">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="filter-tooltip">Reset All Filters</Tooltip>
                }
              >
                {childApplyFilter ? (
                  // eslint-disable-next-line jsx-a11y/interactive-supports-focus
                  <div
                    className="th-icon ic-filter-activate"
                    data-testid="childHandleClearFilter"
                    role="button"
                    onClick={handleClearFilterChild}
                  >
                    <span className="ic-title"> Filter </span>{' '}
                  </div>
                ) : (
                  <div
                    data-testid="childHandleClearFilter"
                    className="th-icon ic-filter"
                  >
                    <span className="ic-title"> Filter </span>{' '}
                  </div>
                )}
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="history-tooltip"> Actions </Tooltip>}
              >
                <div className="th-icon ic-actions">
                  {' '}
                  <PDFExportPanel
                    gridApi={gridApi1}
                    columnApi={columnApi1}
                    fileName={`${contactType}-Available Contacts`}
                    childRef={superChildRef}
                  />
                </div>
              </OverlayTrigger>
            </div>
          </div>
          <div className="clearfix" />
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <div className="frr-tbl-with-feature">
              {ManufacturerData && ManufacturerData.length > 0 ? (
                <TableGrid
                  ref={superChildRef}
                  rowData={childData}
                  onGridReady={onGridReadyChild}
                  columnDefs={manuFactureChildHead}
                  gridHeight={350}
                  onSelectionChanged={(e) => childSelect(e)}
                  onFilterChanged={onFilterChangedChild}
                  setTotal={setChildTotalResultCount}
                  fileName="Manufacturer-Available Contacts"
                  rowSelection="single"
                  childPopup
                  data-testid="onEditingStopped1"
                  frameworkComponents={frameworkComponentsChild}
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                />
              ) : null}
            </div>
          </div>
          <p className="total-results" tabIndex="0">
            Total Results:
            <b>{ChildTotalResultCount?.toLocaleString('en-US')}</b>
          </p>
        </div>
      </div>
    </>
  );
}
export default withRouter(CopyContact);
